import { useMemo } from 'react';
import { DefaultTheme } from '@mui/styles';

type ClassificationChartStyles = {
  VictoryLabelPie: {
    innerRadius: number;
    height: number;
    width: number;
    paddingTop: number;
    paddingBottom: number;
  };
  VictoryChartNoData: {
    height: number;
    width: number;
    innerRadius: number;
  };
};

export const useChartStyles = (
  theme: DefaultTheme
): ClassificationChartStyles => {
  return useMemo(
    () => ({
      VictoryLabelPie: {
        innerRadius: parseInt(theme.spacing(16)),
        height: parseInt(theme.spacing(30.5)),
        width: parseInt(theme.spacing(45)),
        paddingTop: parseInt(theme.spacing(1)),
        paddingBottom: parseInt(theme.spacing(1))
      },
      VictoryChartNoData: {
        height: parseInt(theme.spacing(37.5)),
        width: parseInt(theme.spacing(45)),
        innerRadius: parseInt(theme.spacing(22))
      }
    }),
    [theme]
  );
};
